var map = {
	"./1cs.svg": 381,
	"./QAtest.jpg": 389,
	"./aboutus.jpg": 383,
	"./analysis.jpg": 386,
	"./analysis.png": 777,
	"./app_design.jpg": 387,
	"./client-info.jpg": 385,
	"./develop.jpg": 388,
	"./favicon.svg": 778,
	"./internet.jpg": 380,
	"./iot_device.jpg": 379,
	"./launch1.jpg": 390,
	"./mobile_dev.jpg": 377,
	"./support.jpg": 391,
	"./transformation.jpg": 382,
	"./web_tech.png": 384,
	"./webapp_dev.jpg": 378
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 776;


//////////////////
// WEBPACK FOOTER
// ./src/images ^\.\/.*$
// module id = 776
// module chunks = 0